<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      文锦站<br>
站点介绍<br>
文锦站位于罗湖区春风路与文锦南路交汇处。 春风路北侧是深圳市北斗小学，文锦南路东侧是郎钜御风庭商住楼，文锦南路西侧是文锦中学，春风路北侧是高嘉花园。文锦站装修设计以白色为主色调，局部方柱采用粉紫色，并通过曲线造型与框架组合、局部抬高、管线遮挡等处理手法，使整个空间整体化。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
前湾	06:20	23:00	9号线	3分50秒	5分55秒<br>
文锦	--	--	9号线	3分50秒	5分55秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
前湾	06:20	23:00	9号线	4分25秒	5分55秒<br>
文锦	--	--	9号线	4分25秒	5分55秒<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
前湾	06:20	00:00	9号线	4分钟	5分55秒<br>
文锦	--	--	9号线	4分钟	5分55秒<br><br>

站点出口信息<br><br>
A出入口:<br>
春风路南侧（西）、文锦南路西侧（南）、文锦中学<br><br>
B出入口:<br>
文锦南路东侧（南）、春风路南侧（东）、朗钜御风庭、联城联合大厦、文锦渡口岸、锦星花园<br><br>
C出入口:<br>
文锦南路东侧（北）、文锦大厦、金安大厦、文锦花园、长安大厦、春风路北侧（东）、深圳市北斗小学<br><br>
D出入口:<br>
春风路北侧（西）、文锦南路西侧(北)、高嘉花园<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 文锦中学<br>
14路、69路、83路、97路、229路、381路、M156路、M172路、M205路、M182路、5路<br><br>
B出入口:<br>
公交站名： 北斗小学<br>
14路<br><br>
C出入口:<br>
公交站名： 文锦南路<br>
M182路、M445路、2路、69路、83路、97路、312路、381路、333路、M205路<br><br>
D出入口:<br>
公交站名： 文锦南路<br>
M182路、2路、69路、83路、97路、312路、381路、333路、M205路<br>
  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "jiuhaoxian",
            title: "9号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>